export default __webpack_public_path__ + "static/media/webs123a.07634ea4.png";